<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-form lazy-validation ref="form">
        <v-card-title>Add a new GTIN</v-card-title>
        <v-card-text>
          <v-text-field
            :label="$t('lang.admin.purchase_order.gtin')"
            outlined
            type="text"
            v-model="input.gtin"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            :label="$t('lang.admin.label_description')"
            outlined
            type="text"
            v-model="input.description"
            :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
            :label="$t('lang.admin.label_model')"
            outlined
            type="text"
            v-model="input.model"
          ></v-text-field>
          <v-text-field
            :label="$t('lang.admin.label_season')"
            outlined
            type="text"
            v-model="input.session"
          ></v-text-field>
          <v-text-field
            :label="$t('lang.admin.label_price')"
            outlined
            type="number"
            :rules="[rules.required]"
            v-model="input.price"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <div class="mb-0 col-md-12">
            <v-btn text rounded type="reset" @click="dialog = false">
              {{ $t("lang.admin.purchase_order.btn_cancel") }}
            </v-btn>
            <bx-btn class="mx-2" color="primary" @click="submit">
              {{ $t("lang.admin.purchase_order.add_article") }}
            </bx-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      input: {},
      locationId: localStorage.getItem("location_id"),
      location: null,
      rules: {
        required: (v) =>
          !!v || this.$t("lang.inbound.dashboard.error_required"),
      },
    };
  },
  async mounted() {
    this.location = await this.$api.location.getLocationById(this.locationId);
  },
  methods: {
    open() {
      this.dialog = true;
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        await this.$api.types.create({
          description: this.input.description,
          gtin: this.input.gtin,
          price: this.input.price,
          session: this.input.session,
          model: this.input.model,
          brand_id: this.location.brand,
        });
        this.dialog = false;
        setTimeout(() => {
          this.$emit("close");
        }, 0);
      } catch (error) {
        console.log(error);
      } finally {
        this.input = {};
      }
    },
  },
};
</script>

<style>
</style>